import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

export default function Donate() {
  const [details, setDetails] = useState({
    name: "",
    email: "",
    contact: "",
    amount: "",
  });

  const [impactText, setImpactText] = useState("");
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  // Email validation regex
  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Contact validation with optional country code
  const validateContact = (contact) =>
    /^(\+?\d{1,3})?\d{10}$/.test(contact);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only numbers and optional '+' for amount/contact
    if ((name === "amount" || name === "contact") && value && !/^\+?\d*$/.test(value)) return;

    setDetails((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // Update impact text if amount changes
    if (name === "amount") {
      const num = Number(value);
      if (!num || num < 100) {
        setImpactText("");
        return;
      }

    if (num < 100) {
      setImpactText("");
    }
    else if (num <= 200) setImpactText("Provides notebooks for 5 children.");
    else if (num <= 400) setImpactText("Provides school bags for 3 children.");
    else if (num <= 600) setImpactText("Provides art & craft kits for 5 children.");
    else if (num <= 800) setImpactText("Provides hygiene kits for 4 children.");
    else if (num <= 1000) setImpactText("Provides uniforms for 3 children.");
    else if (num <= 1500) setImpactText("Provides shoes and socks for 5 children.");
    else if (num <= 2000) setImpactText("Provides stationery kits for 10 children.");
    else if (num <= 2500) setImpactText("Funds digital learning content for 5 children.");
    else if (num <= 3000) setImpactText("Provides healthy meals for a classroom.");
    else if (num <= 4000) setImpactText("Supports after-school tutoring for 10 children.");
    else if (num <= 5000) setImpactText("Funds textbooks and learning materials.");
    else if (num <= 7000) setImpactText("Sponsors exam fees for 15 students.");
    else if (num <= 9000) setImpactText("Supports a child’s education for one full term.");
    else if (num <= 10000) setImpactText("Covers a child's school fees for a year.");
    else if (num <= 15000) setImpactText("Sponsors two children for a full academic year.");
    else if (num <= 25000) setImpactText("Helps upgrade classroom infrastructure.");
    else setImpactText("Transforms lives by supporting multiple children in education.");

    }
  };

  const handleDonate = async () => {
    const { name, email, contact, amount } = details;
    const numAmount = Number(amount.trim());
    const newErrors = {};

    // Validations
    if (!name.trim()) newErrors.name = "Name is required";
    if (!validateEmail(email)) newErrors.email = "Invalid email address";
    if (!validateContact(contact)) newErrors.contact = "Invalid phone number";
    if (!numAmount || numAmount < 100) newErrors.amount = "Minimum amount is ₹100";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {

      const API_BASE = "https://plantachild.onrender.com";

      const res = await fetch(`${API_BASE}/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: numAmount }),
      });

      const order = await res.json();
      if (!order.id) throw new Error("Order creation failed");

      // Razorpay options
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Test key
        amount: order.amount,
        currency: "INR",
        name: "PlantAChild NGO",
        description: "Donation",
        order_id: order.id,
        handler: async function (response) {

          const API_BASE = "https://plantachild.onrender.com";
          const verifyRes = await fetch(`${API_BASE}/verify-payment`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              donor: details,
            }),
          });

          const data = await verifyRes.json();
          if (data.success) {
            // Redirect to ThankYou page with donor details
            navigate("/thankyou", {
              state: { donor: details, payment_id: response.razorpay_payment_id },
            });
          } else {
            alert("Payment verification failed.");
          }
        },
        prefill: { name, email, contact },
        theme: { color: "#28a745" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error(err);
      alert("Payment initialization failed.");
    }
  };

  return (
    <section id="donate" className="donate-section">
      <h2>Donate Now</h2>

      <div className="donate-form">
        <input
          name="name"
          placeholder="Name"
          value={details.name}
          onChange={handleChange}
        />
        {errors.name && <small className="error">{errors.name}</small>}

        <input
          name="email"
          placeholder="Email"
          value={details.email}
          onChange={handleChange}
        />
        {errors.email && <small className="error">{errors.email}</small>}

        <input
          name="contact"
          placeholder="Contact (+919876543210)"
          value={details.contact}
          onChange={handleChange}
        />
        {errors.contact && <small className="error">{errors.contact}</small>}

        <input
          name="amount"
          placeholder="Amount (₹100+)"
          value={details.amount}
          onChange={handleChange}
        />
        {errors.amount && <small className="error">{errors.amount}</small>}

        <button onClick={handleDonate}>Proceed to Pay</button>
      </div>

      {impactText && <p className="donation-impact">{impactText}</p>}
    </section>
  );
}
